module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AYBC")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Anchor Yale Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("b.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Babylonian Talmud")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDAG")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Bauer, Danker, Arndt, and Gingrich, "), _c('em', [_vm._v("Greek-English Lexicon of the New Testament and Other Early Christian Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Karl Barth, "), _c('em', [_vm._v("Church Dogmatics")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CEB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Common English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JATS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal of the Adventist Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSNT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal for the Study of the New Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTI")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Journal of Theological Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("m.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Mishnah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NA"), _c('sup', [_vm._v("27/28")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Nestle-Aland "), _c('em', [_vm._v("Novum Testamentum Graece")]), _vm._v(", 27th or 28th ed.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NASB")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New American Standard Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neot")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("Neotestamentica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICNT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NKJV")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New King James Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NLT")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New Living Translation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NRSV")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PG")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Patrologia Graeca. Edited by J.-P. Migne. 162 vols. Paris, 1857–86. "), _c('a', {
    attrs: {
      "href": "http://www.patristica.net/graeca",
      "target": "_blank"
    }
  }, [_vm._v("http://patristica.net/graeca/")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PL")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Patrologia Latina. Edited by J.-P. Migne. 217 vols. Paris, 1844–64. "), _c('a', {
    attrs: {
      "href": "http://www.patristica.net/latina",
      "target": "_blank"
    }
  }, [_vm._v("http://patristica.net/latina/")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Pillar New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Princ.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("First Principles")]), _vm._v(" (Origen)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Sacrifices")])])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_c('em', [_vm._v("On the Sacrifices of Cain and Abel")]), _vm._v(" (Philo)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sanh.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Sanhedrin")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("THNTC")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Two Horizons New Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TNIV")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Today’s New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('p', {
    staticClass: "t-hang"
  }, [_vm._v("Word Biblical Commentary")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8be1212","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Abbreviations.vue
// module id = 72
// module chunks = 0